export interface VideoTrackProps {
  kind: 'descriptions';
  src: string;
  srcLang: string;
  default: true;
}

/**
 * Describes a video's transcript as `<track>` props.
 *
 * There is one transcript per video, not one per language: an Amplience content item belongs
 * to exactly one website ("Website - de-CH", "Website - en-AU", ...), so the language is fixed
 * when the module is placed and the editor uploads the file in that language. srcLang is
 * therefore the page locale.
 *
 * The kind is `descriptions`, not `captions`: these videos are silent loops, so the VTT
 * describes what happens on screen instead of transcribing audio. Note that no browser
 * surfaces a descriptions track to the user today — it is delivered for compliance, and
 * making it visible would be a separate UX decision.
 */
export const getVideoTrackProps = (
  transcriptUrl: string | undefined,
  locale: string
): VideoTrackProps | undefined =>
  transcriptUrl
    ? { kind: 'descriptions', src: transcriptUrl, srcLang: locale, default: true }
    : undefined;
